// Open the command palette from anywhere (buttons, menus) without prop drilling.
export const OPEN_COMMAND_PALETTE_EVENT = "open-command-palette";

export const openCommandPalette = () => window.dispatchEvent(new Event(OPEN_COMMAND_PALETTE_EVENT));
